import React from 'react';
import Tenthgrade_k10 from './tenthgrade_k10';
import Tenthgrade_k10_subjects from './tenthgrade_k10_subjects';
const Tenthgrade_k10soc = () => {
  return (
    <div>
      <Tenthgrade_k10 />
    <Tenthgrade_k10_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Social studies section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Tenthgrade_k10soc;